import request, { formatRequest } from "@/utils/request"

interface saveLabelFeeProps {
  id: number
  shop_id: number
  name: string
  ship_from_type: number // 寄件方国家选择类型 1-所有国家 2-特殊国家
  fee_kind: number // Shipping fee类型 1-无物流费 2-固定费用 3-按实际扣费
  fee_value?: number // 固定扣费金额
}

const APILabelFee = {
  /**
   * 获取销售市场国家选项列表
   */
  getMarketCountryOptions(params) {
    return formatRequest(
      request.get("/go-api/v1/setting/labelFee/getMarketCountryOptions", {
        params,
      }),
    )
  },

  /**
   * 获取Shipping fee列表
   */
  getLabelFeeList() {
    return formatRequest(request.get("/go-api/v1/setting/labelFee/list"))
  },

  /**
   * 获取Shipping fee设置获取详情
   */
  getLabelFeeDetail(params) {
    return formatRequest(
      request.get("/go-api/v1/setting/labelFee/detail", { params }),
    )
  },

  /**
   * Shipping fee 设置保存
   */
  saveLabelFee(params: saveLabelFeeProps) {
    return formatRequest(
      request.post("/go-api/v1/setting/labelFee/save", params),
    )
  },

  /**
   * Shipping fee 设置删除
   */
  deleteLabelFee(params: { id: number }) {
    return formatRequest(
      request.post("/go-api/v1/setting/labelFee/del", params),
    )
  },
}

export default APILabelFee
